import { render, staticRenderFns } from "./PromptLibraryWidget.vue?vue&type=template&id=05e6d804"
import script from "./PromptLibraryWidget.vue?vue&type=script&lang=js"
export * from "./PromptLibraryWidget.vue?vue&type=script&lang=js"
import style0 from "./PromptLibraryWidget.vue?vue&type=style&index=0&id=05e6d804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports